import { render, staticRenderFns } from "./jurisdiction2.vue?vue&type=template&id=7821282f&scoped=true&"
import script from "./jurisdiction2.vue?vue&type=script&lang=js&"
export * from "./jurisdiction2.vue?vue&type=script&lang=js&"
import style0 from "./jurisdiction2.vue?vue&type=style&index=0&id=7821282f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7821282f",
  null
  
)

export default component.exports